import type { CMSFormField } from "~/types/cms";

/**
 * Validates email format.
 */
export function isValidEmail(email: string): boolean {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

/**
 * Validates phone number format (German and international formats).
 * Accepts formats like: +49 123 456789, 0123 456789, +49-123-456789, etc.
 */
export function isValidPhone(phone: string): boolean {
  // Remove spaces, hyphens, parentheses for validation
  const cleaned = phone.replace(/[\s\-()]/g, "");

  // Must contain only digits and optional leading +
  // Length between 6 and 15 digits (international standard)
  const phoneRegex = /^\+?[0-9]{6,15}$/;
  return phoneRegex.test(cleaned);
}

/**
 * Validates a CSS hex colour string (#rgb or #rrggbb).
 * Returns false for null/undefined/non-string so callers can guard inline styles.
 */
export function isValidHexColor(color: string | null | undefined): boolean {
  if (!color || typeof color !== "string") return false;
  return /^#([0-9A-Fa-f]{3}){1,2}$/.test(color);
}

/**
 * Checks if a CMS form field is a phone field based on name or label.
 */
export function isPhoneField(field: CMSFormField): boolean {
  const fieldName = (field.name || "").toLowerCase();
  const fieldLabel = (field.label || "").toLowerCase();
  return (
    fieldName.includes("phone") ||
    fieldName.includes("telefon") ||
    fieldName.includes("tel") ||
    fieldLabel.includes("telefon") ||
    fieldLabel.includes("phone")
  );
}
